export default __webpack_public_path__ + "static/media/home-image2.f9552061.jpg";